var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1478_5968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.503 0H77.4985C68.9389 0 62 6.93892 62 15.4985V15.503C62 24.0626 68.9389 31.0015 77.4985 31.0015H77.503C86.0626 31.0015 93.0015 24.0626 93.0015 15.503V15.4985C93.0015 6.93892 86.0626 0 77.503 0Z",
    fill: "#FF9001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0015 0H31V31.0015H62.0015V0Z",
    fill: "#FF9001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.503 0H15.4985C6.93892 0 0 6.93892 0 15.4985V15.503C0 24.0626 6.93892 31.0015 15.4985 31.0015H15.503C24.0626 31.0015 31.0015 24.0626 31.0015 15.503V15.4985C31.0015 6.93892 24.0626 0 15.503 0Z",
    fill: "#FF9001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.997 0V31.0015H31",
    fill: "#FFA922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0015 15.498C93.0015 17.5337 92.6004 19.5494 91.8213 21.4301C91.0421 23.3108 89.9001 25.0195 88.4605 26.4587C87.0208 27.898 85.3118 29.0395 83.4309 29.8181C81.55 30.5967 79.5341 30.9971 77.4985 30.9965C73.388 30.9965 69.4459 29.3637 66.5394 26.4571C63.6328 23.5506 62 19.6085 62 15.498",
    fill: "#FFA922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0015 31.002H0V62.0035H31.0015V31.002Z",
    fill: "#FF9001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0015 31.002H31V62.0035H62.0015V31.002Z",
    fill: "#FF9001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.503 61.998H15.4985C6.93892 61.998 0 68.937 0 77.4966V77.5011C0 86.0606 6.93892 92.9996 15.4985 92.9996H15.503C24.0626 92.9996 31.0015 86.0606 31.0015 77.5011V77.4966C31.0015 68.937 24.0626 61.998 15.503 61.998Z",
    fill: "#FF9001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0015 61.998H31V92.9996H62.0015V61.998Z",
    fill: "#FF9001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0015 61.998H62V92.9996H93.0015V61.998Z",
    fill: "#FF9001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.997 61.998V92.9996H31",
    fill: "#FFA922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 31.002H93.0015V61.9989",
    fill: "#FFA922"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1478_5968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.6f7a3e90f6a1cb4e8518c1d7a9398b6d.svg";
export { ForwardRef as ReactComponent };